import { render, staticRenderFns } from "./Square.vue?vue&type=template&id=20ce2f09&scoped=true&"
import script from "./Square.vue?vue&type=script&lang=js&"
export * from "./Square.vue?vue&type=script&lang=js&"
import style0 from "./Square.vue?vue&type=style&index=0&id=20ce2f09&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ce2f09",
  null
  
)

export default component.exports